import React from "react";
import { motion } from "framer-motion";
import Education from "./Education";

const Resume = () => {
  return (
    <section
      id="resume"
      className="relative w-full py-10 sm:py-14 border-b border-white/10"
    >
      {/* Ambient glow */}
      <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-[480px] h-48 rounded-full bg-[radial-gradient(ellipse_80%_50%,rgba(255,1,79,0.08),transparent_70%)] blur-2xl" />

      <div className="relative max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center mb-8 sm:mb-10">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, ease: [0.25, 1, 0.5, 1] }}
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-medium uppercase tracking-[0.2em] text-gray-400 backdrop-blur-md mb-5"
          >
            <span className="h-2 w-2 rounded-full bg-designColor animate-pulse" />
            My profile
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.08, ease: [0.25, 1, 0.5, 1] }}
            className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight"
          >
            <span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
              5+ years of experience
            </span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.14, ease: [0.25, 1, 0.5, 1] }}
            className="mt-3 text-gray-400 text-sm sm:text-base max-w-md"
          >
            Building products across web, mobile, and full-stack
          </motion.p>
        </div>

        <Education />
      </div>
    </section>
  );
};

export default Resume;
